import styled from 'styled-components';
import { SchedulingStatusColor } from '../../components/enum/schedulingStatusEnum';
import { StatusNotify, StatusProps } from '../../common/interfaces';

export {
    Container,
    Title,
    TableContainer,
    Pagination,
    ActionButton,
    Table,
    ActionsCell,
    TextFeldClientSearch,
    SearchCard as SchedulingSearchCard,
} from '../sharedTable.styled';

export const StatusCell = styled.td<StatusProps>`
  color: ${({ status }) => SchedulingStatusColor[status] || 'var(--text)'};
  font-weight: 700;
`;

export const StatusMyNotify = styled.td<StatusNotify>`
  color: ${({ status }) => (status ? '#34d399' : 'var(--accent-rose)')};
  font-weight: 700;
`;
